import { useEffect } from 'react';
import { GTMConversions } from '../scripts';
import styled from 'styled-components';
import { fillFormField } from '../../utils/form';

const inquiryFieldName = `inbound_request_type`;

export const ContactForm = ({ sales = false }) => {
  useEffect(() => {
    setTimeout(() => {
      loadForm(sales);
    }, 1000);
  }, []);

  return (
    <Container sales={sales}>
      <div id="contactForm" style={{ width: '100%' }}></div>
    </Container>
  );
};

const Container = styled.div<{ sales: boolean }>`
  width: 100%;
  max-width: 450px;

  ${(p) =>
    p.sales &&
    `
    .hs-${inquiryFieldName} {
      display: none;
    }
  `}
`;

function loadForm(sales = false) {
  //@ts-ignore
  window?.hbspt?.forms?.create?.({
    target: '#contactForm',
    region: 'na1',
    portalId: '22297332',
    formId: '0306d073-688a-46fd-b418-f33d60c59ebd',
    onFormReady: function ($form: any) {
      if (sales) {
        requestAnimationFrame(() => {
          fillFormField($form, inquiryFieldName, 'Sales Inquiry');
        });
      }
    },
    onFormSubmitted: () => GTMConversions.contact(),
    css: `
      .hs-error-msgs,
      .hs-recaptcha {
        display: none;
      }
      
      .field {
        background: #262f40;
        width: 100% !important;
        padding: 8px 16px;
        margin-bottom: 13px;
        position: relative;
      }

      .field label {
        display: block;
        color: #8092b2;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.1em;
        margin-bottom: 8px;
        pointer-events: none;
        text-align: left;
      }

      .field input {
        appearance: none;
        width: 100% !important;
        background: none;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        outline: none;
        padding: 0 !important;
      }

      .field input::placeholder,
      .field textarea::placeholder {
        color: rgba(255, 255, 255, 0.2);
        font-weight: 300;
      }

      .field textarea {
        appearance: none;
        width: 100% !important;
        background: none;
        font-size: 16px;
        line-height: 28px;
        font-weight: bold;
        outline: none;
        resize: none;
        padding: 0 !important;
      }

      .field select {
        appearance: none;
        width: 100%;
        background: none;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        outline: none;
        color: white;
      }

      .field select option {
        background: #262f40;
        color: white;
      }

      .field.hs-fieldtype-select .input {
        position: relative;
      }

      .field.hs-fieldtype-select .input::after {
        content: '';
        pointer-events: none;
        border: solid white;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
        transform: rotate(45deg);
        right: 8px;
        top: 5px;
        position: absolute;
      }

      input[type="submit"] {
        appearance: none;
        font-weight: 500;
        color: white;
        cursor: pointer;
        outline: none !important;
        background-color: rgb(81,192,172);
        border: 1px solid rgb(81,192,172);
        user-select: none;
        text-transform: uppercase;
        padding: 12px 24px;
        font-size: 16px;
        height: 48px;
        width: 100%;
      }

      input[type="submit"]:hover {
        opacity: 0.7;
      }
    `,
  });
}
